<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="예약 기본 설정">

          <!--          <b-form-group label-cols="2" horizontal label="예약기능">-->
          <!--            <b-row align-v="center" class="justify-content-start m-1" no-gutters>-->
          <!--              <b-col md="auto">-->
          <!--                <b-form-radio-group v-model="form.bookingAvailable">-->
          <!--                  <b-form-radio :value="true">사용</b-form-radio>-->
          <!--                  <b-form-radio :value="false">미사용</b-form-radio>-->
          <!--                </b-form-radio-group>-->
          <!--              </b-col>-->
          <!--            </b-row>-->
          <!--          </b-form-group>-->

          <b-form-group label-cols="2" horizontal label="일반예약 승인" class="weight600">
            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col md="auto">
                <b-form-radio-group v-model="form.autoConfirmation">
                  <b-form-radio :value="false" :disabled="!!kakaoId">대기</b-form-radio>
                  <b-form-radio :value="true">실시간</b-form-radio>
                </b-form-radio-group>
              </b-col>
              <span v-if="form.autoConfirmation">최대(</span>
              <b-col cols="1" v-if="form.autoConfirmation === true">
                <b-input-group>
                  <b-input type="number" v-model="form.autoConfirmationCount"></b-input>
                </b-input-group>
              </b-col>
              <span v-if="form.autoConfirmation">)명</span>
              <span v-if="form.autoConfirmation && kakaoId" class="ml-2"> ※ 최대 인원수는 테이블엔조이 예약에서만 적용됩니다.</span>
            </b-row>
          </b-form-group>

          <b-form-group label-cols="2" horizontal label="결제예약 승인" class="weight600">
            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col md="auto">
                <b-form-radio-group v-model="form.paidAutoBooking">
                  <b-form-radio :value="false" :disabled="!!kakaoId">대기</b-form-radio>
                  <b-form-radio :value="true">실시간</b-form-radio>
                </b-form-radio-group>
              </b-col>

              <span v-if="form.paidAutoBooking">최대(</span>
              <b-col cols="1" v-if="form.paidAutoBooking">
                <b-input-group>
                  <b-input type="number" v-model="form.paidAutoBookingMaxHeadcount"></b-input>
                </b-input-group>
              </b-col>
              <span v-if="form.paidAutoBooking">)명</span>
              <span v-if="form.paidAutoBooking && kakaoId" class="ml-2"> ※ 최대 인원수는 테이블엔조이 예약에서만 적용됩니다.</span>
            </b-row>
          </b-form-group>

          <b-form-group label-cols="2" horizontal label="예약가능시간" class="weight600">
            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col md="auto">
                <span>예약시간</span>
              </b-col>
              <b-col cols="2" style="max-width: 135px;" class="ml-2">
                <b-form-select v-model="canBookBefore" :options="canBookBeforeOptions" size="lg" @change="chkChangeTimeSlot"  plain/>
              </b-col>
              <b-col md="auto" class="ml-2">
                <span>전까지 예약 가능</span>
              </b-col>
            </b-row>
          </b-form-group>

          <!-- <b-form-group label-cols="2" horizontal label="예약취소시간" label-v-align-md="top" class="weight600">
              <b-row align-v="center" class="justify-content-start  m-1" no-gutters>
                  <b-col md="auto">
                      <span>예약시간</span>
                  </b-col>
                  <b-col cols="2" style="max-width: 135px;" class="ml-2">
                      <b-form-select v-model="canCancelBefore" :options="canCancelBeforeOptions" plain />
                  </b-col>
                  <b-col md="auto" class="ml-2">
                      <span>전까지 취소 가능</span>
                  </b-col>
              </b-row>
          </b-form-group> -->

          <b-form-group label-cols="2" horizontal label="예약가능기한" class="mb-0 weight600">
            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col md="auto">
                <span>당일로부터</span>
              </b-col>
              <b-col cols="2" style="max-width: 135px;" class="ml-2">
                <b-form-select v-model="form.canBookUntilDays" :options="canBookUntilOptions" @change="chkChangeTimeSlot" plain/>
              </b-col>
              <b-col md="auto" class="ml-2">
                <span>후까지 예약 가능</span>
              </b-col>
            </b-row>
          </b-form-group>

          <br>

          <b-form-group label-cols="2" horizontal label="제공옵션" class="weight600">

            <!--            <b-row>-->
            <!--              <b-colxx xxs="12">-->
            <!--                <b-form>-->
            <!--                  <input-tag :value="form.offeredOptions" v-model="form.offeredOptions"></input-tag>-->
            <!--                </b-form>-->
            <!--              </b-colxx>-->
            <!--            </b-row>-->

            <b-form-tags v-model="form.offeredOptions" no-outer-focus class="mb-2">
              <template v-slot="{ tags, inputAttrs, inputHandlers, tagVariant, addTag, removeTag }">
                <b-input-group class="mb-2">
                  <b-form-input v-bind="inputAttrs" v-on="inputHandlers" placeholder="제공옵션을 입력하세요."
                                class="form-control"></b-form-input>
                  <b-input-group-append>
                    <b-button style="width: 100px;" @click="addTag()" variant="outline-secondary">추가</b-button>
                  </b-input-group-append>
                </b-input-group>
                <div class="d-inline-block" style="font-size: 17px;">
                  <b-form-tag v-for="tag in tags" @remove="removeTag(tag)" :key="tag" :title="tag"
                              variant="outline-primary" class="mr-1">{{ tag }}
                  </b-form-tag>
                </div>
              </template>
            </b-form-tags>

            <!--            <offered-options v-for="(offeredOptions, index) in form.offeredOptions"-->
            <!--                             :key="offeredOptions.id" :data="offeredOptions"-->
            <!--                             @deleteOption="deleteOption"></offered-options>-->
            <!--            <b-row align-v="center" class="justify-content-start ml-4" no-gutters>-->
            <!--              <b-button variant="outline-success" class="mt-2" size="xs" @click.prevent="addOption">옵션 추가-->
            <!--              </b-button>-->
            <!--            </b-row>-->

          </b-form-group>

          <b-form-group label-cols="2" horizontal label="알림수신" class="weight600">

            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col md="auto">
                <b-form-checkbox v-model="form.willReceiveSms" :value='true' :unchecked-value='false'>SMS 문자 알림
                </b-form-checkbox>
              </b-col>
            </b-row>

            <!--            <b-row v-if="form.willReceiveSms">-->
            <!--              <b-colxx xxs="12">-->
            <!--                <b-form>-->
            <!--                  <input-tag validate="digits" :value="form.phoneNumber" v-model="form.phoneNumber"></input-tag>-->
            <!--                </b-form>-->
            <!--              </b-colxx>-->
            <!--            </b-row>-->

            <b-form-tags :tag-validator="tagValidator" v-if="form.willReceiveSms" v-model="form.phoneNumber"
                         no-outer-focus class="mb-2">
              <template v-slot="{ tags, inputAttrs, inputHandlers, tagVariant, addTag, removeTag }">
                <b-input-group class="mb-2">
                  <b-form-input v-bind="inputAttrs" v-on="inputHandlers" placeholder="전화번호를 입력하세요."
                                class="form-control"></b-form-input>
                  <b-input-group-append>
                    <b-button style="width: 100px;" @click="addTag()" variant="outline-secondary">추가</b-button>
                  </b-input-group-append>
                </b-input-group>
                <div class="d-inline-block" style="font-size: 17px;">
                  <b-form-tag v-for="tag in tags" @remove="removeTag(tag)" :key="tag" :title="tag"
                              variant="outline-primary" class="mr-1">{{ tag }}
                  </b-form-tag>
                </div>
              </template>
            </b-form-tags>

            <!--            <phone-number v-if="form.willReceiveSms" v-for="(phoneNumber, index) in form.phoneNumber"-->
            <!--                          :key="phoneNumber.id" :data="phoneNumber" @deleteNumber="deleteNumber"></phone-number>-->

            <!--            <b-row v-if="form.willReceiveSms" align-v="center" class="justify-content-start ml-4" no-gutters>-->
            <!--              <b-button variant="outline-success" class="mt-2" size="xs" @click.prevent="addPhoneNumber">전화번호 추가-->
            <!--              </b-button>-->
            <!--            </b-row>-->
          </b-form-group>

          <b-form-group label-cols="2" horizontal label="">
            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col md="auto">
                <b-form-checkbox v-model="form.willReceiveEmail" :value='true' :unchecked-value='false'>이메일 알림
                </b-form-checkbox>
              </b-col>
            </b-row>

            <!--            <b-row v-if="form.willReceiveEmail">-->
            <!--              <b-colxx xxs="12">-->
            <!--                <b-form>-->
            <!--                  <input-tag validate="email" :value="form.emailAddress" v-model="form.emailAddress"></input-tag>-->
            <!--                </b-form>-->
            <!--              </b-colxx>-->
            <!--            </b-row>-->

            <b-form-tags :tag-validator="tagValidator2" v-if="form.willReceiveEmail" v-model="form.emailAddress"
                         no-outer-focus class="mb-2">
              <template v-slot="{ tags, inputAttrs, inputHandlers, tagVariant, addTag, removeTag }">
                <b-input-group class="mb-2">
                  <b-form-input v-bind="inputAttrs" v-on="inputHandlers" placeholder="이메일 주소를 입력하세요."
                                class="form-control"></b-form-input>
                  <b-input-group-append>
                    <b-button style="width: 100px;" @click="addTag()" variant="outline-secondary">추가</b-button>
                  </b-input-group-append>
                </b-input-group>
                <div class="d-inline-block" style="font-size: 17px;">
                  <b-form-tag v-for="tag in tags" @remove="removeTag(tag)" :key="tag" :title="tag"
                              variant="outline-primary" class="mr-1">{{ tag }}
                  </b-form-tag>
                </div>
              </template>
            </b-form-tags>

            <!--            <email-address v-if="form.willReceiveEmail" v-for="(emailAddress, index) in form.emailAddress"-->
            <!--                           :key="emailAddress.id" :data="emailAddress" @deleteNumber="deleteEmail"></email-address>-->

            <!--            <b-row v-if="form.willReceiveEmail" align-v="center" class="justify-content-start ml-4" no-gutters>-->
            <!--              <b-button variant="outline-success" class="mt-2" size="xs" @click.prevent="addEmailAddress">이메일 추가-->
            <!--              </b-button>-->
            <!--            </b-row>-->

          </b-form-group>

          <b-form-group label-cols="2" horizontal label="야간 SMS 문자 알림 수신(21:00~9:00)" class=" weight600">
            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col md="auto">
                <b-form-radio-group v-model="form.willReceiveSmsAtNight">
                  <b-form-radio :value="true">수신함</b-form-radio>
                  <b-form-radio :value="false">수신 안함</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-form-group>

          <b-form-group label-cols="2" horizontal label="익일 자동 방문완료" class="weight600">
            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col md="auto">
                <b-form-radio-group v-model="form.dayAutoBooked">
                  <b-form-radio :value="true">사용</b-form-radio>
                  <b-form-radio :value="false" :disabled="!!kakaoId">미사용</b-form-radio>
                </b-form-radio-group>
              </b-col>


            </b-row>
          </b-form-group>

          <!-- <b-form-group label-cols="2" horizontal label="미방문시 쿠폰 처리" class="weight600">
      <b-row align-v="center" class="justify-content-start m-1" no-gutters>
        <b-col md="auto">
          <b-form-radio-group v-model="form.unusedCouponDisposalMethod">
            <b-form-radio value="SetVisited">사용 처리</b-form-radio>
            <b-form-radio value="SetCancelled">미사용 처리</b-form-radio>
          </b-form-radio-group>
        </b-col>
      </b-row>
    </b-form-group> -->

          <b-form-group label-cols="2" horizontal label="환불 기준 설정" class="weight600">
            <b-row align-v="center" class="justify-content-start m-1" no-gutters>
              <b-col md="auto">
                <b-form-radio-group v-model="setRefund">
                  <b-form-radio :value="true" @change="setRefundChange(setRefund)">사용</b-form-radio>
                  <b-form-radio :value="false" @change="setRefundChange(setRefund)">미사용</b-form-radio>
                </b-form-radio-group>
                <p v-if="!setRefund">미설정 시 100% 환불됩니다.</p>
                <p v-else>환불 불가 시 0% 입력</p>
                <div v-if="setRefund" class="nnos first">
                  <div v-if="!chkRefundArrayList">
                    <div v-for="(item,idx) in refundArrayList" :key="item.refundType">
                      <div class="d-flex" style="margin-bottom: 8px; ">
                        <div class="col-3 radio " style="padding-left: 0px; margin-top: 16px">
                          <span >{{item.refundType ==0? '당일 방문' : `${item.refundType} 일전`}}</span>
                        </div>
                        <div class="col-sm-9 radio" :style=" idx != refundArrayList.length-1 ?'padding: 0 !important;':''" style="align-items: center">
                          <div class="refInputDiv" v-if="idx != refundArrayList.length-1">
                            <input  type="text" maxlength="3" class="form-control "
                                    style="max-width:110px"
                                    v-model.number="item.percent"
                                    oninput="this.value = this.value.replace(/[^0-9.]/g,'');">
                            <span>% 환불</span>
                          </div>

                          <div class="refInputDiv" style="margin-top: 16px;" v-else>
                            <span class="text-center">{{item.percent}}% 환불</span>
                          </div>
                        </div>
                      </div>
                      <label class="waring" style="display: block" v-if="idx != refundArrayList.length-1">
                        <span v-if="item.percent ==='' " >  값을 넣어주세요.</span>
                        <span v-else-if=" idx!=0 && Number(refundArrayList[idx-1].percent) > Number(refundArrayList[idx].percent) ">  상위 항목에 입력된 환불 비율(%) 보다 작을 수 없습니다.</span>
                      </label>
                    </div>
                    <div class="col-sm-12 d-flex mt-3" style="padding-left: 0px">
                      <b-button variant="outline-success" class="mr-3" @click="newAddRefund">
                        <b-icon icon="plus"></b-icon>
                        환불 기준 추가
                      </b-button>
                      <b-button variant="outline-primary" class="btn btn-default" @click="setNewRefundListDel">삭제
                      </b-button>
                    </div>
                  </div>
                  <div v-else>
                    <label class="waring" >환불 기준 설정 오류 문의요망</label>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-form-group>

          <br>
          <div class="text-center">
            <b-button variant="primary" class="mt-4 ml-2" @click.prevent="onSave">저장</b-button>
          </div>
        </b-card>
      </b-colxx>
    </b-row>
    <b-button variant="outline-primary" class="mt-0" @click.prevent="goBack">뒤로</b-button>
  </div>
</template>

<script>
import InputTag from '../../../components/Form/InputTag'
import 'vue-select/dist/vue-select.css'
import PhoneNumber from "../../../components/Business/SmsPhoneNumber";
import emailAddress from "../../../components/Business/emailAddress";
import offeredOptions from "../../../components/Business/offeredOptions";

import {
  mapGetters,
  mapActions
} from "vuex";

import api from '../../../constants/api'

export default {
  components: {
    'phone-number': PhoneNumber,
    'email-address': emailAddress,
    'offered-options': offeredOptions,
    'input-tag': InputTag,

  },
  props:{
    kakaoId:{
      default: null
    }
  },
  data() {
    return {
      setRefund: false,
      setRefundList: [],
      srNoshow: "",
      tags: [],
      userRole: null,
      phoneNumberId: 0,
      emailId: 0,

      compoId: 0,
      storeCode: this.$route.params.storeCode,
      canBookBefore: null,
      canCancelBefore: null,
      form: {
        bookingAvailable: true,
        autoConfirmation: true,
        autoConfirmationCount: null,
        paidAutoBooking: null,
        paidAutoBookingMaxHeadcount: null,
        bookingOptionCodes: [],
        canBookBeforeDays: null,
        canBookBeforeHours: null,
        canCancelBeforeDays: null,
        canCancelBeforeHours: null,
        canBookUntilDays: null,
        willReceiveSms: false,
        phoneNumber: [],
        willReceiveEmail: false,
        emailAddress: [],
        willReceiveSmsAtNight: false,
        unusedCouponDisposalMethod: null,
        shouldCountAdult: true,
        shouldCountChild: false,
        shouldCountBaby: false,
        offeredOptions: [],
        dayAutoBooked:null
      },
      canBookBeforeOptions: [
        {
          value: 'm15',
          text: '15 분',
        },
        {
          value: 'm30',
          text: '30 분',
        },
        {
          value: 'm45',
          text: '45 분',
        },
        {
          value: 'h1',
          text: '1 시간'
        },
        {
          value: 'h2',
          text: '2 시간'
        },
        {
          value: 'h3',
          text: '3 시간'
        },
        {
          value: 'h4',
          text: '4 시간'
        },
        {
          value: 'h5',
          text: '5 시간'
        },
        {
          value: 'h6',
          text: '6 시간'
        },
        {
          value: 'd1',
          text: '1 일'
        },
        {
          value: 'd2',
          text: '2 일'
        },
        {
          value: 'd3',
          text: '3 일'
        },
        {
          value: 'd7',
          text: '7 일'
        },
        {
          value: 'd10',
          text: '10 일'
        }
      ],
      canCancelBeforeOptions: [{
        value: 'h1',
        text: '1 시간'
      },
        {
          value: 'h2',
          text: '2 시간'
        },
        {
          value: 'h3',
          text: '3 시간'
        },
        {
          value: 'h4',
          text: '4 시간'
        },
        {
          value: 'h5',
          text: '5 시간'
        },
        {
          value: 'h6',
          text: '6 시간'
        },
        {
          value: 'd1',
          text: '1 일'
        },
        {
          value: 'd2',
          text: '2 일'
        },
        {
          value: 'd3',
          text: '3 일'
        },
        {
          value: 'd4',
          text: '4 일'
        },
        {
          value: 'd5',
          text: '5 일'
        },
        {
          value: 'd6',
          text: '6 일'
        },
        {
          value: 'd7',
          text: '7 일'
        }
      ],
      canBookUntilOptions: [{
        value: '15',
        text: '15 일'
      },
        {
          value: '30',
          text: '30 일'
        },
        {
          value: '60',
          text: '60 일'
        },
        {
          value: '90',
          text: '90 일'
        },
        {
          value: '120',
          text: '120 일'
        },
        {
          value: '150',
          text: '150 일'
        }
      ],
      refundArrayList:[

      ],
      chkRefundArrayList:false,
      alertChk:false,

    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName'])
  },
  mounted() {
    this.userRole = this.currentUser.userRole.split('_')[0]
    this.loadData()
  },
  methods: {

    numberCheck(val, sidx) {
      const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]/;

      // 한글, 영문 체크
      if (reg.exec(val.srcElement.value) !== null) {
        val.path[0].value = val.path[0].value.replace(/[^0-9]/g, '');
        if (sidx == 'srNoshow') {
          this.srNoshow.replace(/[^0-9]/g, '');
        }
      }
      if (isNaN(parseFloat(val.srcElement.value))) {
        val.path[0].value = '';
        if (sidx == 'srNoshow') {
          this.srNoshow = '';
        }
      }

      if (Number(val.srcElement.value) > 100) {
        alert('최대 입력은 100% 입니다.');
        val.path[0].value = "";
        if (sidx !== 'srNoshow') {
          this.setRefundList[sridx].refPercent = '';
        } else {
          this.srNoshow = '';
        }

      }
    },

    goBack() {
      this.$router.back();
    },

    makeTimeValue(days, hours) {
      let time = '';
      if (days !== undefined) {
        if (days !== null && days > 0) {
          time = 'd' + days;
        } else {
          time = 'h' + hours;
        }
      }else{
        time = 'm' + hours;
      }
      return time
    },

    loadData() {
      var vm = this

      let reqURL = ''
      if (this.userRole == "BRAND") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.bookingSettings)
      } else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.bookingSettingsStr)
      }

      const params = {
        storeCode: this.storeCode
      }
      this.$http.get(reqURL, {
        params: params,
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        if (res.data.code === "OK") {
          // console.log("예약정보", res.data.data)
          const _data = res.data.data.bookingSettings

          //예약가능
          this.form.bookingAvailable = _data.bookingAvailable

          //일반예약승인
          this.form.autoConfirmation = _data.autoBooking
          this.form.autoConfirmationCount = _data.autoBookingMaxHeadcount

          //결제예약승인
          this.form.paidAutoBooking = _data.paidAutoBooking
          this.form.paidAutoBookingMaxHeadcount = _data.paidAutoBookingMaxHeadcount

          //예약가능시간
          this.form.canBookBeforeDays = _data.canBookTillDaysBefore
          this.form.canBookBeforeHours = _data.canBookTillHoursBefore
          if (_data.canBookTillMinutesBefore !== null) {
            this.canBookBefore = this.makeTimeValue(undefined, _data.canBookTillMinutesBefore)
          } else {
            this.canBookBefore = this.makeTimeValue(_data.canBookTillDaysBefore, _data.canBookTillHoursBefore)
          }


          //예약취소시간
          this.form.canCancelBeforeDays = _data.canCancelTillDaysBefore
          this.form.canCancelBeforeHours = _data.canCancelTillHoursBefore
          // this.canCancelBefore = this.makeTimeValue(_data.canCancelTillDaysBefore, _data.canCancelTillHoursBefore)

          //예약가능기한
          this.form.canBookUntilDays = _data.canBookTillDaysAfter

          this.form.willReceiveSms = _data.willReceiveSms
          this.form.willReceiveEmail = _data.willReceiveEmail

          /** *************************************************************************************************/
          //제공옵션 코드리스트
          _data.offeredOptions.forEach((val, index) => {
            vm.form.offeredOptions.push(val)
            // vm.form.offeredOptions.push({id: vm.compoId++, offeredOption: val})
          });

          //알림수신 전화번호 수정
          _data.phoneNumbers.forEach((val, index) => {
            vm.form.phoneNumber.push(val)
            // vm.form.phoneNumber.push({id: vm.compoId++, phoneNo: val})
          });

          //알림수신 이메일 수정
          _data.emailAddresses.forEach((val, index) => {
            vm.form.emailAddress.push(val)
            // vm.form.emailAddress.push({id: vm.compoId++, email: val})
          });

          /** *************************************************************************************************/

          this.form.willReceiveSmsAtNight = _data.willReceiveSmsAtNight
          // this.form.unusedCouponDisposalMethod = _data.noShowCouponDisposal
          this.form.shouldCountAdult = _data.shouldCountAdult
          this.form.shouldCountChild = _data.shouldCountChild
          this.form.shouldCountBaby = _data.shouldCountBaby;
          this.form.dayAutoBooked = _data.dayAutoBooked;
          let refset = _data.refundSettings;

          if (refset.length !== 0) {

            this.setRefund = true;
          } else {
            this.setRefund = false;
          }
          this.setRefundList = [];


          // 에러 수기 처리용
          if(this.setRefund){
            this.refundArrayList = _data.refundSettings
            this.refundArrayList.forEach((item,idx)=>{
              if(item.refundType != idx){
                this.chkRefundArrayList = true
              }
              if(idx == this.refundArrayList.length-1 && item.percent != 100){
                this.refundArrayList.push({refundType : idx+1,
                  percent:100
                })
              }
            })
          }

          console.log(this.refundArrayList)


        } else {
          throw 400
        }
      }).catch(err => {
        console.log(err);
      })

    },

    addPhoneNumber() {
      this.form.phoneNumber.push({
        id: this.compoId++,
        phoneNo: ''
      })
    },

    deleteNumber(id) {
      this.form.phoneNumber = this.form.phoneNumber.filter(item => item.id !== id)
    },

    addEmailAddress() {
      this.form.emailAddress.push({
        id: this.compoId++,
        email: ''
      })
    },

    deleteEmail(id) {
      this.form.emailAddress = this.form.emailAddress.filter(item => item.id !== id)
    },

    addOption() {
      this.form.offeredOptions.push({
        id: this.compoId++,
        offeredOption: ''
      })

    },

    deleteOption(id) {
      this.form.offeredOptions = this.form.offeredOptions.filter(item => item.id !== id)
    },

    //예약설정변경
    onSave() {
      let warning = false
      if(!this.chkRefundArrayList){
        for(let i = 0 ; i<this.refundArrayList.length-1;i++){
          if(this.refundArrayList[i].percent ==0){
            warning = true
            break;
          }
          if(i>0){
            if(this.refundArrayList[i-1].percent > this.refundArrayList[i].percent){
              warning = true
              break;
            }
          }
        }
        if(warning){
          alert("환불 기준 설정을 확인해 주세요.")
          return
        }
      }else{
        alert("환불기준 설정 오류입니다. 관리자에게 문의주세요.")
        return
      }

      //환불 기준설정 배열 다시만들기

      //환불 기준설정 배열 다시만들기 끝

      let reqURL = ''
      if (this.userRole == "BRAND") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.bookingSettingsUpdate)
      } else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.bookingSettingsUpdateStr)
      }

      let canBookTillDaysBefore = null;
      let canBookTillHoursBefore = null;
      let canCancelTillDaysBefore = null;
      let canCancelTillHoursBefore = null;
      let canBookTillMinutesBefore = null;

      if (this.canBookBefore != null) {
        if (this.canBookBefore.substr(0, 1) == 'd') {
          // console.log(this.canBookBefore)
          canBookTillDaysBefore = !isNaN(Number(this.canBookBefore.substr(1, this.canBookBefore.length))) ? Number(this.canBookBefore.substr(1, this.canBookBefore.length)) : null
          canBookTillHoursBefore = null;
          canBookTillMinutesBefore = null;
        } else if(this.canBookBefore.substr(0, 1) !== 'm') {
          canBookTillDaysBefore = null
          canBookTillHoursBefore = !isNaN(Number(this.canBookBefore.substr(1, this.canBookBefore.length))) ? Number(this.canBookBefore.substr(1, this.canBookBefore.length)) : null
          canBookTillMinutesBefore = null;
        }else{
          canBookTillDaysBefore = null;
          canBookTillHoursBefore = null;
          canBookTillMinutesBefore = !isNaN(Number(this.canBookBefore.substr(1, this.canBookBefore.length))) ? Number(this.canBookBefore.substr(1, this.canBookBefore.length)) : null
        }
      }

      // if (this.canCancelBefore != null) {
      //     if (this.canCancelBefore.substr(0, 1) == 'd') {
      //         // console.log(this.canBookBefore)
      //         canCancelTillDaysBefore = Number(this.canBookBefore.substr(1, this.canBookBefore.length))
      //         canCancelTillHoursBefore = null
      //     } else {
      //         canCancelTillDaysBefore = null
      //         canCancelTillHoursBefore = Number(this.canBookBefore.substr(1, this.canBookBefore.length))
      //     }
      // }

      let params = {
        bookingSettings: {
          autoBooking: this.form.autoConfirmation,
          autoBookingMaxHeadcount: this.form.autoConfirmationCount,
          paidAutoBooking: this.form.paidAutoBooking,
          paidAutoBookingMaxHeadcount: this.form.paidAutoBookingMaxHeadcount,

          canBookTillDaysBefore: canBookTillDaysBefore,
          canBookTillHoursBefore: canBookTillHoursBefore,
          canCancelTillDaysBefore: canCancelTillDaysBefore,
          canCancelTillHoursBefore: canCancelTillHoursBefore,
          canBookTillMinutesBefore: canBookTillMinutesBefore,
          canBookTillDaysAfter: this.form.canBookUntilDays,
          offeredOptions: this.form.offeredOptions,
          willReceiveSms: this.form.willReceiveSms,
          phoneNumbers: this.form.willReceiveSms ? this.form.phoneNumber : null,
          willReceiveEmail: this.form.willReceiveEmail,
          emailAddresses: this.form.willReceiveEmail ? this.form.emailAddress : null,
          willReceiveSmsAtNight: this.form.willReceiveSmsAtNight,
          // noShowCouponDisposal: this.form.unusedCouponDisposalMethod,
          // refundSettings: this.refundSettings,

          refundSettings: this.refundArrayList,
          dayAutoBooked: this.form.dayAutoBooked
        },
        storeCode: this.storeCode
      }

      console.log(params)

      if (params.bookingSettings.autoBooking == null) {
        alert("일반예약 자동승인 여부를 선택하세요.")
        return
      }

      if (params.bookingSettings.autoBooking) {
        if (params.bookingSettings.autoBookingMaxHeadcount == null || params.bookingSettings.autoBookingMaxHeadcount < 1) {
          alert("일반예약 자동승인 여부를 확인하세요.")
          return
        }
      }

      if (params.bookingSettings.paidAutoBooking == null) {
        alert("결졔예약 자동승인 여부를 선택하세요.")
        return
      }

      if (params.bookingSettings.paidAutoBooking) {
        if (params.bookingSettings.paidAutoBookingMaxHeadcount == null || params.bookingSettings.paidAutoBookingMaxHeadcount < 1) {
          alert("결제예약 자동승인 여부를 확인하세요.")
          return
        }
      }

      if (params.bookingSettings.canBookTillDaysBefore == null && params.bookingSettings.canBookTillHoursBefore == null && params.bookingSettings.canBookTillMinutesBefore == null) {
        alert("예약가능시간을 확인하세요.")
        return
      }
      // if (params.bookingSettings.canCancelTillDaysBefore == null && params.bookingSettings.canCancelTillHoursBefore == null) {
      //     alert("예약취소시간을 확인하세요.")
      //     return
      // }

      if (params.bookingSettings.canBookTillDaysAfter == null) {
        alert("예약가능기한을 선택하세요.")
        return
      }

      if (params.bookingSettings.willReceiveSms == null) {
        alert("SMS 문자알림 수신 여부를 선택하세요.")
        return
      }

      if (params.bookingSettings.willReceiveSms && params.bookingSettings.phoneNumbers.length < 1) {
        alert("SMS 문자알림 수신 전화번호를 입력하세요.")
        return
      }

      if (params.bookingSettings.willReceiveEmail == null) {
        alert("이메일 알림 수신 여부를 선택하세요.")
        return
      }

      if (params.bookingSettings.willReceiveEmail && params.bookingSettings.emailAddresses.length < 1) {
        alert("이메일 알림 수신 이메일 주소를 입력하세요.")
        return
      }

      if (params.bookingSettings.willReceiveSmsAtNight == null) {
        alert("야간알림 수신 여부를 선택하세요.")
        return
      }
      if (params.bookingSettings.dayAutoBooked == null) {
        alert("익일 자동 방문완료 여부를 선택하세요.")
        return
      }

      // if (params.bookingSettings.noShowCouponDisposal == null) {
      //     alert("미방문시 쿠폰처리 정책을 선택하세요.")
      //     return
      // }

      //SMS 문자알림 수신 여부를 선택하세요.
      //   당일로부터 며칠 후까지 예약가능한지 입력하세요.
      //   미방문시 쿠폰처리 정책을 선택하세요.
      //   이메일 알림 수신 여부를 선택하세요.
      //   야간알림 수신 여부를 선택하세요.

      this.$http.post(reqURL, params, {
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        // console.log(res)
        if (res.data.code === "OK") {
          alert('변경하였습니다. ')
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })

    },

    tagValidator(tag) {
      const regExp = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})([0-9]{3,4})([0-9]{4})$/;
      return regExp.exec(tag);
    },

    tagValidator2(tag) {
      const reg = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/
      return reg.test(tag)
    },
    newAddRefund(){
      let tmp = this.refundArrayList.length
      if(tmp==9){
        alert("최대입니다.")
        return
      }else{
        this.refundArrayList.splice(tmp-1,0,{refundType : tmp-1, percent:0})
        this.refundArrayList.forEach((item,idx)=>{
          item.refundType = idx
          if(idx == this.refundArrayList.length-1){
            item.percent = 100
          }
        })
      }
    },
    setNewRefundListDel(){
      let tmp = this.refundArrayList.length
      if(tmp==2){
        alert("최소입니다.")
        return
      }else{
        this.refundArrayList.splice(tmp-2,1)
        this.refundArrayList.forEach((item,idx)=>{
          item.refundType = idx
          if(idx == this.refundArrayList.length-1){
            item.percent = 100
          }
        })

      }
    },
    setRefundChange(val){

      if(!val){
        this.refundArrayList=[
          {refundType : 0,
            percent:0
          },
          {refundType : 1,
            percent:100
          }
        ]
      }else{
        this.refundArrayList=[

        ]
      }
    },
    chkChangeTimeSlot(){
      this.alertChk = true
    }

  },

  watch: {

    tag(val) {
      console.log(val);
    },

    'form.willReceiveSms'(value) {
      // console.log(value);
    },
    'form.willReceiveEmail'(value) {
      // console.log(value);
    },
    canBookBefore(value) {
      if (value.indexOf('h') !== -1) {
        this.canBookBeforeHours = value.replace('h', '')
        this.canBookBeforeDays = null
      } else {
        this.canBookBeforeDays = value.replace('d', '')
        this.canBookBeforeHours = null
      }
    },
    canCancelBefore(value) {
      if (value.indexOf('h') !== -1) {
        this.canCancelBeforeHours = value.replace('h', '')
        this.canCancelBeforeDays = null
      } else {
        this.canCancelBeforeDays = value.replace('d', '')
        this.canCancelBeforeHours = null
      }
    }
  }
}
</script>

<style scoped>
.nnos input,
.nnos select {
  display: inline-block;
}

.refInputDiv {
  display: inline-block;
  width: 172px;
  margin-left: 10px;
}

.srdivbox {
  margin-top: 10px;
}

.refTitle {
  min-width: 120px;
  display: inline-block;
}

.mt-1 {
  margin-top: 10px;
}

button.btn.btn-default.del {
  background: #efefef;
  border-radius: 0;
  border: 1px solid #c7c7c7;
  vertical-align: inherit;
}

.nnos {
  min-width: 400px;
}

.nnos .srdivbox select {
  height: inherit !important;
  vertical-align: middle;
}

.waring {
  color: red;
  margin-top: 5px;
}
</style>
